import Service from "../../services"

const Research = {
    namespaced: true,
    state: {
        newResearchCount: '',
        allResearchCount: '',
        verifyResearchCount: '',
        researchApproveCount: 0,
        rfApproveCount: 0,
        cancelResearchCount: ''
    },
    mutations: {
        SET_NEW_RESEARCH_COUNT_ITEM: (state, data) => {
            state.newResearchCount = data;
        },
        SET_ALL_RESEARCH_COUNT_ITEM: (state, data) => {
            state.allResearchCount = data;
        },
        SET_COUNT_VERIFY_RESEARCH: (state, val) => {
            state.verifyResearchCount = val;
        },
        SET_COUNT_RESEARCH_APPROVE: (state, val) => {
            state.researchApproveCount = val;
        },
        SET_COUNT_APPROVE_RF_LEADER: (state, val) => {
            state.rfApproveCount = val;
        },
        SET_COUNT_CANCEL_RESEARCH_COUNT_ITEM: (state, data) => {
            state.cancelResearchCount = data;
        },
        createState: (state) => {
            state.newResearchCount = '';
            state.allResearchCount = '';
            state.verifyResearchCount = '';
            state.researchApproveCount = 0;
            state.rfApproveCount = 0;
            state.cancelResearchCount = 0;
        }
    },
    actions: {
        getResearchList({ commit }, page) {
            return Service.Research.getResearchList(page).then(res => {
                let count = res.waitForConsiderResearchCount;
                commit("SET_ALL_RESEARCH_COUNT_ITEM", count);
                return res.allResearch;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getNewResearchList({ commit }, page) {
            return Service.Research.getNewResearchList(page).then(res => {
                let count = res.newResearchCount;
                commit("SET_NEW_RESEARCH_COUNT_ITEM", count);
                return res.research;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getCancelResearch({ commit }, page) {
            return Service.Research.getCancelResearch(page).then(res => {
                let count = res.cancelResearchCount;
                commit("SET_COUNT_CANCEL_RESEARCH_COUNT_ITEM", count);
                return res.data;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveResearchVerify({ commit }, data) {
            return Service.Research.saveResearchVerify(data).then(res => {
            }).catch(err => {
                return Promise.reject(err)
            })
        },

        sendApproveMail({ commit }, data) {
            return Service.Research.sendApproveMail(data).then(res => {
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        previewApproveMail({ commit }, data) {
            return Service.Research.previewApproveMail(data).then(res => {
                return res
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        previewConsiderResultMail({ commit }, data) {
            return Service.Research.previewConsiderResultMail(data).then(res => {
                return res
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        researchEmailResend({ commit }, data) {
            return Service.Research.researchEmailResend(data).then(res => {
                return res
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        sendPostApproveMail({ commit }, data) {
            return Service.Research.sendPostApproveMail(data).then(res => {
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        sendReviewerMail({ commit }, researchID) {
            return Service.Research.sendReviewerMail(researchID).then(res => {
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        saveChooseReviewer({ commit }, data) {
            return Service.Research.saveChooseReviewer(data).then(res => {
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        updatetypeConsideration({ commit }, data) {
            return Service.Research.updatetypeConsideration(data).then(res => {
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        researchReceive({ commit }, data) {
            return Service.Research.researchReceive(data).then(res => {
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getResearchVerify({ commit }, data) {
            return Service.Research.getResearchVerify(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getVerifiedResearchList({ commit }, data) {
            return Service.Research.getVerifiedResearchList(data).then(res => {
                let count = res.countNotHaveConsiderType;

                commit('SET_COUNT_VERIFY_RESEARCH', count);
                return res.research;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getPaginateResearchByReviewerID({ commit }, data) {
            return Service.Research.getPaginateResearchByReviewerID(data.page, data.id).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getPaginateResearchByReviewerIDFilter({ commit }, data) {
            return Service.Research.getPaginateResearchByReviewerIDFilter(data.page, data.id, data.considerType, data.reviewType).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getPaginatePostApproveByReviewerIDFilter({ commit }, data) {
            return Service.Research.getPaginatePostApproveByReviewerIDFilter(data.page, data.id, data.filter).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRF({ commit }, data) {
            return Service.Research.getRF(data.page, data.id, data.filter).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getRFApprove({ commit }, data) {
            return Service.Research.getRFApprove(data.page, data.filter, data.researcherName, data.researchCode).then(res => {
                let verifyRF = res.ResearchAmendmentCount + res.AdverseEventCount + res.DeviationReportCount + res.ProgressReportCount + res.ResearchSummarizeCount + res.ResearchTerminationCount + res.AdverseDrugEventCount;
                commit('SET_COUNT_APPROVE_RF_LEADER', verifyRF)
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        deleteResearchVerify({ commit }, data) {
            return Service.Research.deleteResearchVerify(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getSubcommittee({ commit }, data) {
            return Service.Research.getSubcommittee(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getInitialResearch({ commit }) {
            return Service.Research.getInitialResearch().then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getInitialResearchList({ commit }) {
            return Service.Research.getInitialResearchList().then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        showReviewerSelect({ commit }, id) {
            return Service.Research.showReviewerSelect(id).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        showChooseReviewer({ commit }, id) {
            return Service.Research.showChooseReviewer(id).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        showReviewerSelectAll({ commit }) {
            return Service.Research.showReviewerSelectAll().then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        updateConsiderResult({ commit }, data) {
            return Service.Research.updateConsiderResult(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        previewCOA({ commit }, data) {
            return Service.Research.previewCOA(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getPaginateResearchFilter({ commit }, data) {
            return Service.Research.getPaginateResearchFilter(data).then(res => {
                return res.research;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getResearchApprove({ commit }, data) {
            return Service.Research.getPaginateResearchFilter(data).then(res => {
                let count = res.countCanApprove;
                commit('SET_COUNT_RESEARCH_APPROVE', count);
                return res.research;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getResearch({ commit }, id) {
            return Service.Research.getResearch(id).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        searchResearchCode({ commit }, searchData) {
            return Service.Research.searchResearchCode(searchData).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        createState({ commit }) {
            commit("createState");
        },
        getFormResearch1({ commit }, id) {
            return Service.Research.getFormResearch1(id).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getResearchLog({ commit }, id) {
            return Service.Research.getResearchLog(id).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getFormResearch2({ commit }, id) {
            return Service.Research.getFormResearch2(id).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        searchReviewer({ commit }, data) {
            return Service.Research.searchReviewer(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getResearchHistory({ commit }, data) {
            return Service.Research.getResearchHistory(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },

        acceptCancelResearch({ commit }, data) {
            return Service.Research.acceptCancelResearch(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err);
            })
        },
        cancelResearchCode({ commit }, data) {
            return Service.Research.cancelResearchCode(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err);
            })
        },
        getSummaryFile({ commit }, id) {
            return Service.Research.getSummaryFile(id).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        }

    }
}

export default Research;
